export var Markets = /*#__PURE__*/function (Markets) {
  Markets["CN"] = "cn";
  return Markets;
}({});
//# sourceMappingURL=helpers.js.map